import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";
import { Welder } from "../welders";

export type WeldListFilters = {
  datasheetId?: string;
  onlyWeldsNotMade: boolean;
  onlyWeldsReadyForNdt: boolean;
  onlyRepairWelds: boolean;
};

export type ParalloyWeld = {
  weldId: string;
  weldNumber: string;
  datasheet: string;
  jointType: string;
  fillerType: string;
  fillerBatch: string;
  component1: string;
  component2: string;
  itemNumber: string;
  wpsNumber: string;
  uniqueIdA: string;
  uniqueIdB: string;
  meltNumberA: string;
  meltNumberB: string;
  region: string;
  status: string;
  welders: Welder[];
};

export type CheckoutWeldsResponse = {
  success: boolean;
  completed: ParalloyWeld[];
};

export type InspectorWeld = {
  weldId: string;
  weldNumber: string;
  datasheet: string;
  uniqueIdA: string;
  uniqueIdB: string;
  meltNumberA: string;
  meltNumberB: string;
  techniques: string;
  drawingId: string;
};

export type InspectorRow = {
  weldId: string;
  weldNumber: string;
  uniqueIdA: string;
  uniqueIdB: string;
  meltNumberA: string;
  meltNumberB: string;
  drawingId: string;
  technique: string;
  accept?: boolean;
  defect: string;
  attachment?: File;
  comment: string;
};

export function getWelderWeldList(subProjectId: string, filters: Partial<WeldListFilters>) {
  const params = convertToURLSearchParams({ subProjectId, ...filters });
  return api.getPaginated<ParalloyWeld[]>(`paralloy/rbi/welds?${params.toString()}`);
}

export function checkoutWelds(welds: ParalloyWeld[]) {
  const weldIds = welds.map((x) => x.weldId);
  return api.post<CheckoutWeldsResponse>("paralloy/rbi/checkout", weldIds);
}

export function getCheckedOutWelds() {
  return api.get<ParalloyWeld[]>("paralloy/rbi/checkout");
}

export function saveParalloyWelds(welds: ParalloyWeld[]) {
  return api.post("paralloy/rbi/welds", welds);
}

export function getInspectorWeldList(subProjectId: string, filters: Partial<WeldListFilters>) {
  const params = convertToURLSearchParams({ subProjectId, ...filters });
  return api.getPaginated<InspectorWeld[]>(`paralloy/rbi/inspector/welds?${params.toString()}`);
}

export function getInspections(weldIds: string[]) {
  return api.post<InspectorRow[]>("paralloy/rbi/inspector/inspections", weldIds);
}

export function saveInspectorRows(inspections: InspectorRow[]) {
  return api.post("paralloy/rbi/inspector", inspections);
}
